export const SET_ZONE = "SET_ZONE";
export const SET_ZONES = "SET_ZONES";
export const ADD_ZONE = "ADD_ZONE";
export const UPDATE_ZONE = "UPDATE_ZONE";
export const DELETE_ZONE = "DELETE_ZONE";
